import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import ReactTable from "react-table";
import "react-table/react-table.css"
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import "react-tabs/style/react-tabs.css";
import ReactExport from "react-export-excel";
import { Link , Redirect } from 'react-router-dom';
import matchpointlogo from '../assets/images/matchpointlogo.png';
import calender from '../assets/images/calender.png';
import logout from '../assets/images/logout.png';
import '../main.css'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import "react-table/react-table.css";
import axios from "axios";
import "antd/dist/antd.css";
import { Table, Tooltip } from "antd";

import Grid from '@material-ui/core/Grid';
import host from './ipaddress';
import Common_function from './Common_function';
import { osName,osVersion,browserName,deviceType } from 'react-device-detect';
import ApiUrlCall from './Api/apiurl';
import AuthService from '../Config/AuthService';


var gl_requestcode;
var gl_requesttype;
var gl_orderno;
var gl_list = [];
var gl_req_data = []
var timercounter = 0;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


class Cars24NRT extends Component{
  constructor(props){
    super(props);

    const token = localStorage.getItem("token")
    
    let loggedIn = true
    if(token == null){
      loggedIn = false
    }
    this.state={
      loggedIn,

      value: '',
      date: new Date(),
      host : host ,
      totalCount:'',
      startTime: "12:00 am",
      showStartTime: false,
      showEndTime: false,
      endTime: "11:59 pm",
      sendEndTime: "23:59",
      sendStartTime: "00:00",
      startDate: new Date(),
      endDate: new Date(),
      checkebox_value: [],
      user1 : localStorage.getItem("username"),
      userGroups: localStorage.getItem('user_groups'),

      lonNoList : [],
      is_checked: true,
      //radius : 0,
      options : [],
      tableData : [],
      isDisabled : false,
      loadingProgress: '',
      dataReceived: false,

    }
    this.onChange = this.onChange.bind(this);
   
    this.showPassword = this.showPassword.bind(this);    
  }

componentDidMount(){
$("#loading-image").hide();
$(".loading-icon").hide();
this.sendDataToGenerateReport()
}

onRowClick = (state, rowInfo, instance) => {
  return {
    onClick: (e, handleOriginal) => {
      if (handleOriginal) {
        handleOriginal();
      }
      $(this).remove();
    }
  };
};




onChange(e) {

  if (["new_password","confirm_password"].includes(e.target.id))
  {
    if (document.getElementById('new_password').value ==
              document.getElementById('confirm_password').value) {
          document.getElementById('resetpass').disabled = false;
          document.getElementById('lbl_err').innerHTML = "Matched";
          document.getElementById('lbl_err').style.color = 'green';
        } else {          
          document.getElementById('lbl_err').innerHTML = "Not Matched"
          document.getElementById('lbl_err').style.color = 'red';
          document.getElementById('resetpass').disabled = true;
      }
  }
}







logoutHandler =(e) =>{
  var user_id = localStorage.getItem("user")
  var sha256 = require('js-sha256');
  var userid_enc = sha256(user_id);

  var active_session = {
    start_time : Common_function.ServerDateTime(localStorage.getItem("cache focus date")),
    end_time: Common_function.ServerDateTime(new Date())
  }
   console.log(active_session ,"logout time detail")
  var device_detail = [{
   event_id : 1,
  unique_id : userid_enc,
    os_version : osVersion,
    model_name: osName,
    value : active_session,user_id:user_id,
  
  }]
  
  const analytics_details = {
    data : device_detail , source : 2
  };

  
 JSON.stringify(analytics_details)

//  console.log("hello..", analytics_details)
        
  ApiUrlCall.send_analytics(analytics_details).then(response => {
     
    if (response.status === 200) {
      return

    }
  }
  )
  // Stop session services
  AuthService.stopTokenRefresh();
  AuthService.stopHeartbeat();

  // End session and logout on server
  AuthService.endSession().catch(err => console.log('End session error:', err));
  AuthService.logOut().catch(err => console.log('Logout error:', err));

  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  localStorage.removeItem("mobile_number");
  localStorage.removeItem("username");
  localStorage.setItem('cache focus date','')


  gl_requestcode="";
  gl_requesttype="";
  gl_orderno="";
  gl_list = [];
  gl_req_data = []
  timercounter = 0;
  setTimeout(function(){
    window.location.reload()
  }, 1000);  
}

showPassword = (e) => {
  var inputs = document.getElementsByClassName('mpassword');
  Array.prototype.forEach.call(inputs, function(x) {
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  })
}


onChange2 = (e) =>{
  this.setState({
    checkebox_value : e
  },() => {
    if (this.state.checkebox_value.length == 50){
      this.setState({
        isDisabled : true,
      })
      alert("You can select maximum of 50 checkbox.")
    }else{
      this.setState({
        isDisabled : false,
      })
    }
  })
} 


createServerDateTime = (date, time) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if(month <= 9){
    month = '0'+month
  }
  if(day <= 9){
    day = '0'+day
  }
  var datetime = year + "-" + month + "-" + day + " " + time + ":" + "00"
  return datetime
}

dateValidation(start, end) {
  var start = new Date(start);
  var end = new Date(end);  
  if (start > end) {
    return false
  } else {
    return true
  }
}

sendDataToGenerateReport = (e) =>{
  const {endDate,startDate,sendEndTime,sendStartTime} = this.state
  if (this.state.startDate == null){
      alert("Please select start date.")
      return
  }else{
      var start_date_time = this.createServerDateTime(startDate,sendStartTime)
    }


  this.hideAllDropDown()

    var data = JSON.stringify({"date" : start_date_time,})
    console.log(data ,"datt")

    // Track start time for performance monitoring
    const startTime = performance.now();

    $.ajax({
     url: this.state.host+'/v1/mpgps/landerDashboard/tr_cars24_nrt_report/',

     // url: this.state.host+'/v1/mpgps/landerDashboard/get_cars24_data/',

      dataType: 'json',
      type:'post',
      data:data,
      beforeSend: function(request) {
          request.setRequestHeader("authorization", localStorage.getItem("token"));
          request.setRequestHeader('api-head', JSON.stringify({"user_id":localStorage.getItem("user"),"username":localStorage.getItem("username")}));
          $("#loading-image").show();
          $(".loading-icon").show();
          this.setState({
            loadingProgress: 'Fetching data from server...',
            dataReceived: false
          });
        }.bind(this),
      success: function(data, textStatus, xhr) {
        const fetchTime = ((performance.now() - startTime) / 1000).toFixed(2);

        // Read custom headers from backend
        const backendTime = xhr.getResponseHeader('X-Backend-Time');
        const responseSize = xhr.getResponseHeader('X-Response-Size');
        const recordCount = xhr.getResponseHeader('X-Record-Count');

        // Log performance breakdown
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        console.log('📊 PERFORMANCE BREAKDOWN:');
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        console.log(`⚙️  Backend Processing: ${backendTime || 'N/A'}`);
        console.log(`📦 Response Size: ${responseSize || 'N/A'}`);
        console.log(`📝 Record Count: ${recordCount || data.data.length.toLocaleString()}`);
        console.log(`🌐 Network Transfer: ${fetchTime}s (includes backend time)`);
        console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

        this.setState({
          loadingProgress: `Received ${data.data.length.toLocaleString()} records. Rendering table...`,
          dataReceived: true
        });

        // Use setTimeout to allow the loading message to update before heavy rendering
        setTimeout(() => {
          this.setState({
            tableData : data.data,
            loadingProgress: '',
            dataReceived: false
          },() =>{
            $("#loading-image").hide();
            $(".loading-icon").hide();
            const totalTime = ((performance.now() - startTime) / 1000).toFixed(2);
            const renderTime = (totalTime - fetchTime).toFixed(2);

            console.log(`🎨 Frontend Rendering: ${renderTime}s`);
            console.log(`⏱️  TOTAL TIME: ${totalTime}s`);
            console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

            if(this.state.tableData.length == 0){
              alert("No data found.")
            } else {
              console.log(`✅ Successfully loaded ${this.state.tableData.length.toLocaleString()} records`);
            }
          })
        }, 100);

      }.bind(this),
      error: function(xhr, status, err) {
        console.error(this.props.url, status, err.toString());
        console.log('fail');
        // alert("Internal Server Error");
        $("#loading-image").hide();
        $(".loading-icon").hide();
        this.setState({
          loadingProgress: '',
          dataReceived: false
        });
        if(err.toString() == "Forbidden"){
         //this.logoutHandler()
        }
      }.bind(this)
    });
}

convertTime =(sec) =>{
  var hours = Math.floor(sec/3600);
  (hours >= 1) ? sec = sec - (hours*3600) : hours = '0';
  //(hours >= 10 && hours <= 1) ? sec = sec - (hours*3600) : hours = '0'+hours;
  var min = Math.floor(sec/60);
  (min >= 1) ? sec = sec - (min*60) : min = '00';
  (sec < 1) ? sec='00' : void 0;

  (min.toString().length == 1) ? min = '0'+min : void 0;    
  (sec.toString().length == 1) ? sec = '0'+sec : void 0; 

  return hours+' Hr:'+min+' Min :'+sec+" Sec";
}


////////////////////////////////////////////////////////

showStartDate = (e) => {
  $(e.currentTarget).next().slideToggle(200, "swing")
}

showStartDate = (e) => {
  $(e.currentTarget).next().slideToggle(200, "swing")
  $('#end_date_cal').slideUp()
  this.setState({
    showStartTime: false,
    showEndTime: false,
  })
}

StartdateClicked = date => {
  var isoStartDate = date
  this.setState({ startDate: isoStartDate }, () => {
    // Automatically call API when date is selected
    this.sendDataToGenerateReport()
  })
  $('#start_date_cal').slideUp(200)
}

dateFormate = (rdate) => {
  var date = new Date(rdate);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (day < 10) {
    day = '0' + day;
  }
  if (month < 10) {
    month = '0' + month;
  }
  var convertDate = day + '/' + month + '/' + year
  return convertDate
}

hideAllDropDown = () => {
  $('#start_date_cal').hide()
  this.setState({
    showStartTime: false,
  })
}

/////////////////////////////////////////////////////////

render(){



  const headers = [
    { label: 'Sr No.', key: 'sr_no' },
    { label: 'Los No.', key: 'Los_No' },
    { label: 'Customer Name', key: 'Customer_Name' },
    { label: 'Cust Phone No', key: 'Cust_Phone_No' },
    { label: 'Serial_number_id', key: 'Serial_number_id' },
    { label: 'Last_Report_DateTime Time', key: 'Last_Report_DateTime' },
    { label: 'NRT_Days', key: 'NRT_Days' },
    { label: 'Status', key: 'Status' },
    { label: 'Tracker_Model', key: 'Tracker_Model' },
    { label: 'Car_Registration_Number', key: 'Car_Registration_Number' },
    { label: 'Battery_Voltage', key: 'Battery_Voltage' },
    { label: 'Latitude', key: 'Latitude' },
    { label: 'Longitude', key: 'Longitude' },
    { label: 'Battery_Disconnected_Time', key: 'Battery_Disconnected_Time' },
    { label: 'Battery_Disconnect_Location', key: 'Battery_Disconnect_Location' },
  
  ];

  var minDate = new Date(); 
  minDate.setDate(minDate.getDate() - 90);
  if(this.state.loggedIn === false){
      return <Redirect to="/" />
    }


  const columns=[
  {
    Header: <Tooltip title="Sr No.">Sr No.</Tooltip>,
    accessor: "sr_no",
    style:{
      textAlign:"center"
    },
    Cell: (row) => { return <div>{row.index+1}</div>},
    width:100,
    minWidth:100,
    maxWidth:100
  },
  {
    Header: <Tooltip title="Los No.">Los No.</Tooltip>,
    accessor: "Los_No",
    style:{
      textAlign:"center"
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
    width:100,
    minWidth:100,
    maxWidth:100,
  },
  {
    Header: <Tooltip title="Customer_Name">Customer_Name</Tooltip>,
    accessor: "Customer_Name",
    style:{
      textAlign:"center"
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
    width:100,
    minWidth:100,
    maxWidth:100,
  },    
  {
    Header: <Tooltip title="Cust_Phone_No">Cust_Phone_No</Tooltip>,
    accessor: "Cust_Phone_No",
    sortable:true,
    style:{
      textAlign:"center",
      // 'whiteSpace': 'unset'
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
    width:100,
  },
  {
    Header: <Tooltip title="Serial_number_id">Serial_number_id</Tooltip>,
    accessor: "Serial_number_id",
    sortable:true,
    style:{
      textAlign:"center",
      // 'whiteSpace': 'unset'
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
  },
  {
    Header: <Tooltip title="Last_Report_DateTime">Last_Report_DateTime</Tooltip>,
    accessor: "Last_Report_DateTime",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="NRT_Days">NRT_Days</Tooltip>,
    accessor: "NRT_Days",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Status">Status</Tooltip>,
    accessor: "Status",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Tracker_Model">Tracker_Model</Tooltip>,
    accessor: "Tracker_Model",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Car_Registration_Number">Car_Registration_Number</Tooltip>,
    accessor: "Car_Registration_Number",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Battery_Voltage">Battery_Voltage</Tooltip>,
    accessor: "Battery_Voltage",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Latitude">Latitude</Tooltip>,
    accessor: "Latitude",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Longitude">Longitude</Tooltip>,
    accessor: "Longitude",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Battery_Disconnected_Time">Battery_Disconnected_Time</Tooltip>,
    accessor: "Battery_Disconnected_Time",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Battery_Disconnect_Location">Battery_Disconnect_Location</Tooltip>,
    accessor: "Battery_Disconnect_Location",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
]


  return (
    <div>
      {/*header component start*/}
      <div className="navbar navbar-default">
        <div className="container-fluid pl-0">
              <div className="navbar-header">
                <a className="header-logo">
                <Link to="/lenderdashboard"><img src={matchpointlogo} alt="matchpointlogo" width="300" className="logo"/></Link>
                </a>
              </div>
          <div className="nav navbar-nav navbar-right">
          <div className=" list-inline mb-0">
          <div id="profile_menu" className="list-inline-item fs-21 fc-red text-capitalize border-right cursor-pointer usernamemenu "
          onMouseOver={(e) => {
            //$("#profile_menu").toggle()
          }}
          onMouseLeave={(e) => {
            //$("#profile_menu").toggle()
          }}
          >
            Welcome, {this.state.user1}<span className="color-orange">
            </span>
            {/* <ul>
                <li><a href="#" data-toggle="modal" data-target="#resetPassword" >Change Password</a></li>
            </ul>  */}
             <ul>
          
          {this.state.userGroups[0] === '5' && this.state.userGroups[2] === '7' ? (
            <li>
               <Link to="/Api_integration" style={{ color: 'black', textDecoration: 'none',  }} className="custom-link" >
                 
                 <span style={{ textDecoration: 'none' }} >  Api Integration </span>

               </Link>
          </li> ) : null}
        
        </ul>

          </div>
          
          <div className="list-inline-item">
              <a onClick={e=>this.logoutHandler(e)} className="cursor-pointer">
                <img src={logout} alt="logout-logo" width="30"/>
              </a>
          </div>
          </div>
          </div>
      </div>
    </div>
    {/*header component end*/}

      {/* Range component start*/}
      <div className="container-fluid" style={{paddingTop: '20px', paddingBottom: '15px', backgroundColor: '#f8f9fa'}}>
        <div className="row align-items-end" style={{maxWidth: '900px', margin: '0 auto', paddingLeft: '15px', paddingRight: '15px'}}>
          {/* Date Selection */}
          <div className="col-md-4" style={{marginBottom: '10px', position: 'relative'}}>
            <label style={{fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', display: 'block'}}>
              📅 Select Date
            </label>
            <div className="gray-shadow" style={{width: '100%', maxWidth: '240px', position: 'relative'}}>
              <div className="input_div" onClick={this.showStartDate} style={{cursor: 'pointer'}}>
                <input
                  type="text"
                  placeholder="Select Date"
                  id="start_date"
                  disabled
                  value={this.dateFormate(this.state.startDate)}
                  className="journey_input"
                  style={{cursor: 'pointer'}}
                />
                <img src={calender} className="calender_icon" alt="calendar"/>
              </div>
              <div
                className="calendar_parent"
                id="start_date_cal"
                style={{
                  position: 'absolute',
                  width: '320px',
                  maxWidth: '90vw',
                  backgroundColor: '#ffffff',
                  zIndex: 9999,
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                  padding: '15px',
                  borderRadius: '8px',
                  display: 'none',
                  left: '0',
                  top: '100%',
                  marginTop: '5px'
                }}
              >
                <Calendar
                  selectRange={false}
                  onChange={this.StartdateClicked}
                  value={this.state.startDate}
                  maxDate={this.state.date}
                  minDate={minDate}
                />
              </div>
            </div>
          </div>

          {/* Generate Report Button */}
          <div className="col-md-4" style={{marginBottom: '10px'}}>
            <button
              type="submit"
              id="submit_id"
              className="btn btn-dark submit-btn"
              onClick={this.sendDataToGenerateReport}
              style={{
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: '500',
                minWidth: '150px',
                marginBottom: '0'
              }}
            >
              🔄 Generate Report
            </button>
          </div>

          {/* Export Button */}
          <div className="col-md-4" style={{marginBottom: '10px'}}>
            <CSVLink
              data={this.state.tableData}
              headers={headers}
              filename={"nrt_report.csv"}
              className="btn btn-md btn-dark export-btn"
              style={{
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: '500',
                minWidth: '150px',
                textDecoration: 'none',
                display: 'inline-block'
              }}
            >
              📥 Export Report
            </CSVLink>
          </div>
        </div>
      </div>
        {this.state.tableData.length > 0 && (
          <div style={{backgroundColor: '#fff', padding: '12px 0', borderTop: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0'}}>
            <p className="text-center" style={{color: '#333', fontSize: '15px', fontWeight: '600', margin: '0'}}>
              📊 Total Records: <span style={{color: '#ff5722', fontSize: '16px'}}>{this.state.tableData.length.toLocaleString()}</span>
            </p>
          </div>
        )}
        {/*Range component end */}

        {/* Dashboardtable component start */}
          <div className="red2">
            <div className="plr-20">
              <ReactTable columns={columns}
                  getTdProps={this.onRowClick}
                  ref={r => (this.reactTable = r)}
                  data={this.state.tableData}
                  showPagination={true}
                  pageSizeOptions = {[100, 500, 1000, 2000, 5000]}
                  defaultPageSize={100}
                  style={{
                    maxHeight: "630px" // This will force the table body to overflow and scroll, since there is not enough room
                  }}
                  className="-striped -highlight"
                  >
                </ReactTable>
              <div className="loading-icon" id="myDiv">
                <img id="loading-image" / >
                {this.state.loadingProgress && (
                  <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    color: 'white',
                    padding: '25px 40px',
                    borderRadius: '10px',
                    zIndex: 10000,
                    fontSize: '16px',
                    textAlign: 'center',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                    minWidth: '300px'
                  }}>
                    <div style={{marginBottom: '15px'}}>
                      {this.state.dataReceived ? '✅' : '⏳'}
                    </div>
                    <div style={{fontWeight: 'bold', marginBottom: '10px'}}>
                      {this.state.loadingProgress}
                    </div>
                    {!this.state.dataReceived && (
                      <div style={{fontSize: '12px', color: '#ccc', marginTop: '10px'}}>
                        Please wait while we fetch your data...
                      </div>
                    )}
                    {this.state.dataReceived && (
                      <div style={{fontSize: '12px', color: '#4CAF50', marginTop: '10px'}}>
                        Preparing table display...
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        {/* Dashboardtable component end */}

        {/* Reset Password model window start here */}
        <div class="modal fade" id="resetPassword" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close closebutton" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                <h4 class="modal-title">Change Your Account Password</h4>
              </div>
              <form href="" method="post" >
                <div class="modal-body">
                  <div class="form-group">
                    {/* <label for="accountEmail">Account Email</label> */}
                    <span class="help-block">Old Password.</span>
                    <input  id="old_password" type="password" onChange={this.onChange} class="form-control mpassword" required="required" name="old_password" />
                    <span  class="help-block">New Password.</span>
                    <input id="new_password" type="password" minlength="8" onChange={this.onChange} class="form-control mpassword" required="required" name="new_password" />
                    <span class="help-block ">Confirm Password.</span>
                    <input id="confirm_password" type="password" minlength="8" onChange={this.onChange} class="form-control mpassword" required="required" name="confirm_password" />
                  </div>
                  <input type="checkbox" onChange={this.showPassword} /> Show Password
                  <br/>
                  <label for="error-msg" id="lbl_err"></label>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default btn-sm btn-icon" data-dismiss="modal">Cancel</button>
                  <button type="input" id="resetpass" onClick={this.postData} name="submit" value="resetPass" class="btn btn-success btn-sm btn-icon"> Change Password</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      {/* Reset Password model window end here */}
                          
    </div>
        )
    }
}
export default Cars24NRT
